import {TicketStatus} from "../../tickets/types/tickets.types";


export enum NotificationAction {

  none,
  onboarding_schedule,
  contact_us,
  start_interaction,
  resend_email_confirm,
  ticket

}

export enum NotificationStatus {

  appointment,
  success,
  warning,
  destructive
}

export interface UserNotificationOverviewDto {
  hasNewNotifications: boolean;
  notifications: UserNotificationDto[];
}

export interface UserNotificationDto {

  id: number;
  mainLabel: string;
  subLabel: string;

  frontScreen: boolean;
  newNotification: boolean;
  closeAble: boolean;

  createdOn: string;
  imageUrl: string;
  text: string;

  showUrl: boolean;
  urlText: string;
  url: string;
  actionText: string;

  serviceId: number;

  action: NotificationAction;
  status: NotificationStatus;
  ticketStatus: TicketStatus;

  // following properties are set at frontend
  ticketStatusLabel?: string;
  ticketStatusIcon?: string;
  ticketStatusStyle?: {color: string, background: string};

}

export interface UserNotificationActionGroupDto{
  action: NotificationAction;
  notifications: UserNotificationDto[];
}
